var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nothing-box",style:({ marginTop: _vm.top})},[_c('img',{attrs:{"src":_vm.nodataIcon,"alt":""}}),_c('span',{class:_vm.getCustomClass},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }